import { useEffect, useState, useRef, useContext, createContext } from "react";
import { useParams, useNavigate } from "react-router-dom";
import axios from "axios";
import Select from 'react-select';
	
import guestii_gif from '../../assets/images/guestii_gif.gif'
import styles from "./Hub.module.css"
import TableUtil from '../Utils/TableUtil';
import PieModule from './PieModule';
import Ratings from './Ratings'
import Tags from './Tags'
import Promoters from './Promoters'


const DashboardModule = ({ indEvent }) => {
	const [activeTab, setActiveTab] = useState("Invited")
	const [data, setData] = useState(indEvent.guestiis.reverse())
	const invited = indEvent.guestiis.reduce((sum, { plusOnes }) => sum + 1 + (Number(plusOnes) || 0), 0);
	const accepted = indEvent.guestiis.filter(g => g.accepted).length
	const admitted = indEvent.guestiis.filter(g => g.admitted).length
	

	const handleTab = (tab) => {
		setActiveTab(tab)

		switch (tab) {
			case 'Invited':
				setData(indEvent.guestiis.reverse())
				break;
			case 'Accepted':
				setData(indEvent.guestiis.filter(a => a.accepted).reverse())
				break;
			case 'Admitted':
				setData(indEvent.guestiis.filter(a => a.admitted).reverse())
				break;
		}
	}

	function formatDate(dateString) {
	    const date = new Date(dateString);

	    const dd = String(date.getDate()).padStart(2, '0');
	    const mm = String(date.getMonth() + 1).padStart(2, '0');
	    const yy = String(date.getFullYear()).slice(-2);

	    return `${dd}/${mm}/${yy}`;
	}

	function formatTime(dateString) {
	  const date = new Date(dateString);

	  const hours = date.getHours();
	  const minutes = String(date.getMinutes()).padStart(2, '0');
	  const seconds = String(date.getSeconds()).padStart(2, '0');

	  return `${hours}:${minutes}:${seconds}`;
	}

	return (
		<div className={styles.dashboard_container}>
			<div className={styles.dashboard_stats}>
				<button className={`${styles.dashboard_stat_box} ${activeTab === "Invited" && styles.dashboard_stat_box_active}`} onClick={() => handleTab("Invited")}>
					<div className={styles.dashboard_stat_heading}>
						<i className={`fa-solid fa-users ${styles.s3}`}></i>
						<p className={styles.xs3}>Guestiis Invited</p>
					</div>

					<p className={`${styles.m1} ${styles.dashboard_stat_value}`}>{invited} Invited</p>
				</button>

				<button className={`${styles.dashboard_stat_box} ${activeTab === "Accepted" && styles.dashboard_stat_box_active}`} onClick={() => handleTab("Accepted")}>
					<div className={styles.dashboard_stat_heading}>
						<i className={`fa-solid fa-envelope-circle-check ${styles.s3}`}></i>
						<p className={styles.xs3}>Guestiis Accepted</p>
					</div>

					<p className={`${styles.m1} ${styles.dashboard_stat_value}`}>{accepted} Accepted</p>
				</button>

				<button className={`${styles.dashboard_stat_box} ${activeTab === "Admitted" && styles.dashboard_stat_box_active}`} onClick={() => handleTab("Admitted")}>
					<div className={styles.dashboard_stat_heading}>
						<i className={`fa-solid fa-qrcode ${styles.s3}`}></i>
						<p className={styles.xs3}>Guestiis Admitted</p>
					</div>

					<p className={`${styles.m1} ${styles.dashboard_stat_value}`}>{admitted} Admitted</p>
				</button>
			</div>

			<div className={styles.dashboard_content}>
				<div className={styles.dashboard_content_main}>
					<div className={styles.dashboard_content_heading}>
						<i className={`fa-solid fa-${activeTab === "Invited" ? "users" : activeTab === "Accepted" ? "envelope-circle-check" : "qrcode"} ${styles.s3}`}></i>
						<p className={styles.s1}>{activeTab} Log</p>
					</div>

					{data && data.length > 0
						?
							<div className={styles.admissions_outer}>
								{data.map((d, i) => (
					  				<div className={styles.admissions_container}>
										<div className={styles.event_line}>
											<div className={styles.line_circle}/>
											{(i !== data.length-1) && <div className={styles.line}/>}
										</div>


										<div className={`${styles.guestii_admissions_container}`}>
											<div className={`${styles.guestii_admissions_ind}`}>
												<div className={styles.guestii_inner_split}>
													<div className={`${styles.guestii_profile_rounded}`}><i className={`fa-solid fa-user ${styles.s1}`}></i></div>

													<div className={styles.guestii_profile_info}>
														<p className={styles.s1}>{d.first_name} {d.last_name} {((!d.first_name || d.first_name === "") && (!d.last_name || d.last_name === "")) && "-"}</p>
														<p className={`${styles.xs2}`}>{d.phone || "-"}</p>
													</div>
							                    </div>

							                    <div className={styles.admission_stamp}>
							                    	<p className={`${styles.xs3}`}>{(activeTab === "Invited" || activeTab === "Accepted") ? "Invited" : "Admitted"} by <span>{`${activeTab === "Admitted" ? `${d.admitted_by.first_name} ${d.admitted_by.last_name}` : ((d.main_source.first_name && d.main_source.first_name !== "") || (d.main_source.last_name && d.main_source.last_name !== "")) ? `${d.main_source.first_name} ${d.main_source.last_name}` : d.main_source.email ? d.main_source.email : d.main_source.phone ? d.main_source.phone : d.main_source.phone ? d.main_source.phone : "-"}`}</span>{d.source && ' as '}<span>{d.source ? "+1" : ""}</span></p>
							                    	<p className={styles.xs3}>{activeTab} at <span>{formatDate(activeTab === "Invited" ? d.invited_date : activeTab === "Accepted" ? d.accepted_date : d.admitted_date)} @ {formatTime(activeTab === "Invited" ? d.invited_date : activeTab === "Accepted" ? d.accepted_date : d.admitted_date)}</span></p>
							                	</div>
											</div>
										</div>
					  				</div>
								))}
							</div>
						: <div className={styles.invite_first}><p className={`${styles.m1}`}>{activeTab === "Invite" ? "Invite your first " : "None of your "}<span>Guestiis</span>{activeTab === "Invite" ? " to start!" : activeTab === "Accepted" ? " have accepted yet!" : " have been admitted!"}</p></div>
					}
				</div>

				<div className={styles.dashboard_content_sub_container}>
					<button className={styles.dashboard_content_btn}>
						<i className={`fa-solid fa-download ${styles.m3}`}></i>

						<div className={styles.dashboard_content_btn_container}>
							<p className={styles.s1}>Downoad Lists</p>
							<p className={styles.xs3}>Export lists for static use</p>
						</div>
					</button>

					<div className={styles.dashboard_content_sub}>
						<div className={styles.dashboard_content_heading}>
							<i className={`fa-solid fa-${activeTab === "Invited" ? "users" : activeTab === "Accepted" ? "envelope-circle-check" : "qrcode"} ${styles.s3}`}></i>
							<p className={styles.s1}>{activeTab} Pie Chart</p>
						</div>

						<div className={styles.chart_container}>
							{data && data.length > 0
								? <PieModule raw={indEvent.guestiis}/>
								: <div className={styles.invite_first_inner}><p className={`${styles.m1}`}>{activeTab === "Invite" ? "Invite your first " : "None of your "}<span>Guestiis</span>{activeTab === "Invite" ? " to start!" : activeTab === "Accepted" ? " have accepted yet!" : " have been admitted!"}</p></div>
							}
						</div>
					</div>
				</div>

			</div>
		</div>
	)
}

const GuestiiTopbar = ({ indEvent, setNodes, setNodesOG, setNodesFull, nodes, nodesOG, nodesFull, setIsFocused }) => {
	const [guestiiSearchText, setGuestiiSearchText] = useState("")

	useEffect(() => {
		const handleFilters = () => {
			let filteredGuestiis;

			if (guestiiSearchText && guestiiSearchText.length > 0) {
				const indEventGuestiis = [...indEvent.guestiis]
				const searchTrimmed = guestiiSearchText.trim().toLowerCase();

				let storedMatches = []
				filteredGuestiis = indEventGuestiis.filter(g => {
					const guestiiFullName = `${g.first_name} ${g.last_name}`.toLowerCase();
					const guestiiPhone = (g.phone || '').toLowerCase();
					const matchMade = guestiiFullName.includes(searchTrimmed) || guestiiPhone.includes(searchTrimmed);
					if (matchMade) storedMatches.push(g._id.toString())
					const matchingMadeSource = !matchMade ? g.source ? storedMatches.includes(g.source.toString()) : false : false

					return matchMade || matchingMadeSource
				})
			} else {
				filteredGuestiis = [...indEvent.guestiis]
			}


			const groupedBySource = filteredGuestiis.sort((a, b) => {
              const firstCmp = a.first_name.localeCompare(b.first_name);
              if (firstCmp !== 0) return firstCmp;
              return a.last_name.localeCompare(b.last_name);
            }).reduce((acc, { source, main_source, _id }) => {
			  	const key = (main_source && main_source.email) ? 'admin' : source || 'admin';

			  	if (!acc[key]) acc[key] = [];
			  	acc[key].push(_id);

			  	return acc;
			}, {});


			setNodes(groupedBySource)
		}

		handleFilters()
	}, [guestiiSearchText])

	return (
		<div className={styles.guestii_topbar}>
			<div className={styles.guestii_topbar_search}>
				<i className={`fa-solid fa-magnifying-glass ${styles.m1}`}></i>
				{guestiiSearchText === "" && <p className={`${styles.s1}`}>Search for any Guestii...</p>}

				<input
					type="text"
					className={styles.s1}
					onChange={(input) => setGuestiiSearchText(input.target.value)}
					// onFocus={() => setShowingLabel(false)}
					// onBlur={() => setShowingLabel(true)}
					// onClick={() => setShowingLabel(false)}
					value={guestiiSearchText}
				/>
			</div>

			<button className={styles.guestii_topbar_add} onClick={() => setIsFocused(true)}>
				<i className={`fa-solid fa-plus ${styles.s3}`}></i>
				<p className={`${styles.s1}`}>Invite</p>
			</button>
		</div>
	)
}

const GuestiiSidebar = ({ indEvent, setNodes, setNodesOG, setNodesFull, nodes, nodesOG, nodesFull }) => {
	const [tagOptions, setTagOptions] = useState([])
	const [promoterOptions, setPromoterOptions] = useState([])
	const [selectedFilters, setSelectedFilters] = useState([])


	const generateQuickId = () => {
		const now = new Date();
		const timestamp = now.getTime();
		const random = Math.floor(Math.random() * 10000);

		return `${timestamp}-${random}`;
	};

	useEffect(() => {
		const handleTags = async () => {
			const eventTags = indEvent.guestiis.map(g => (g.tags && g.tags.length > 0) ? g.tags.map(t => t.tag).flat() : []).flat()

			let tagsRaw;
			if (eventTags && eventTags.length > 0) {
				const allTags = ["VIP", "CREW", "MEDIA", "STAFF", "GA"].concat(eventTags)
				tagsRaw = [...new Set(allTags)]
			} else {
				tagsRaw = ["VIP", "CREW", "MEDIA", "STAFF", "GA"]
			}

			const tagsWithIds = tagsRaw.map(t => {
				return {
					tag: t,
					id: generateQuickId()
				}
			})

			setTagOptions(tagsWithIds)
		}

		const handlePromoters = async () => {
			const eventPromoters = indEvent.guestiis.filter(g => g.main_source?.role?.name === "Promoter").map(gi => `${gi.main_source.first_name} ${gi.main_source.last_name}`)
			const promotersDeDupped = [...new Set(eventPromoters)]
			const promotersWithIds = promotersDeDupped.map(p => {
				return {
					promoter: p,
					id: generateQuickId()
				}
			})

			setPromoterOptions(promotersWithIds)
		}

		handleTags()
		handlePromoters()
	}, [indEvent]);


	const toggleFilters = (filter) => {
		setSelectedFilters((prev) => {
			const filtered = prev.find(p => p.id === filter.id)
				? [...prev].filter(f => f.id !== filter.id)
				: [...prev, filter]

			return filtered
		})
	}

	useEffect(() => {
		const handleFilters = () => {
			
			let filteredGuestiis;

			if (selectedFilters.length > 0) {
				const indEventGuestiis = [...indEvent.guestiis]

				const tagNames = tagOptions.filter(t => selectedFilters.map(s => s.id).includes(t.id)).map(n => n.tag)
				const promoterNames = promoterOptions.filter(p => selectedFilters.map(s => s.id).includes(p.id)).map(n => n.promoter)
				const filterNames = tagNames.concat(promoterNames)

				let storedMatches =[]
				filteredGuestiis = indEventGuestiis.filter(g => {
					const guestiiTags = g.tags ? g.tags.map(t => t.tag) : []
					const tagMatch = guestiiTags.some(tag => filterNames.includes(tag));

					const guestiiPromoter = (g.main_source && g.main_source.role) ? `${g.main_source.first_name} ${g.main_source.last_name}` : false
					const promoterMatch = guestiiPromoter ? filterNames.includes(guestiiPromoter) : false

					const matchMade = tagMatch || promoterMatch
					if (matchMade) storedMatches.push(g._id.toString())
					const matchingMadeSource = !matchMade ? g.source ? storedMatches.includes(g.source.toString()) : false : false

					return matchMade || matchingMadeSource
				})
			} else {
				filteredGuestiis = [...indEvent.guestiis]
			}


			const groupedBySource = filteredGuestiis.sort((a, b) => {
              const firstCmp = a.first_name.localeCompare(b.first_name);
              if (firstCmp !== 0) return firstCmp;
              return a.last_name.localeCompare(b.last_name);
            }).reduce((acc, { source, main_source, _id }) => {
			  	const key = (main_source && main_source.email) ? 'admin' : source || 'admin';

			  	if (!acc[key]) acc[key] = [];
			  	acc[key].push(_id);

			  	return acc;
			}, {});

			setNodes(groupedBySource)
		}

		handleFilters()
	}, [selectedFilters])

	return (
		<div className={styles.guestii_sidebar}>
			<div className={styles.sidebar_heading}>
				<i className={`fa-solid fa-filter ${styles.m1}`}></i>
				<p className={`${styles.s1}`}>Filter Guestiis</p>
			</div>

			<div className={styles.sidebar_content_container}>
				<div className={styles.sidebar_filter_container}>
					<div className={styles.sidebar_heading}>
						<i className={`fa-solid fa-tag ${styles.s3}`}></i>
						<p className={`${styles.xs3}`}>Tags</p>
					</div>

					<div className={styles.filter_container}>
						{tagOptions.map((tag) => (
							<div className={styles.filter_inner_container}>
								<button className={`${styles.filter_btn} ${selectedFilters.find(f => f.id === tag.id) && styles.filter_btn_active}`} onClick={() => toggleFilters(tag)}>
									{selectedFilters.find(f => f.id === tag.id) && <i className={`fa-solid fa-check ${styles.xs2}`}></i>}
								</button>

								<p className={`${styles.xs3}`}>{tag.tag}</p>
							</div>
						))}
					</div>
				</div>

				{(promoterOptions && promoterOptions.length > 0) &&
					<div className={styles.sidebar_filter_container} style={{ marginTop: '1.5rem' }}>
						<div className={styles.sidebar_heading}>
							<i className={`fa-solid fa-envelope ${styles.s3}`}></i>
							<p className={`${styles.xs3}`}>Promoters</p>
						</div>

						<div className={styles.filter_container}>
							{promoterOptions.map((promoter) => (
								<div className={styles.filter_inner_container}>
									<button className={`${styles.filter_btn} ${selectedFilters.find(f => f.id === promoter.id) && styles.filter_btn_active}`} onClick={() => toggleFilters(promoter)}>
										{selectedFilters.find(f => f.id === promoter.id) && <i className={`fa-solid fa-check ${styles.xs2}`}></i>}
									</button>
									<p className={`${styles.xs3}`}>{promoter.promoter}</p>
								</div>
							))}
						</div>
					</div>
				}
				
			</div>
		</div>
	)
}

const GuestiiTableDisplay = ({ indEvent, mainLoading, mainGuestii, setMainGuestii, handleDelete, setIndEvent, showRatings, setShowRatings, toggledMenu, setToggledMenu, showTags, setShowTags, setNodes, setNodesOG, setNodesFull, nodes, nodesOG, nodesFull }) => {
	const navigate = useNavigate();
	const containerRef = useRef(null);
	const [isLoading, setIsLoading] = useState(false)
	const [plusOnes, setPlusOnes] = useState({})
	const [plusOneChanges, setPlusOneChanges] = useState({})
	const [menuPos, setMenuPos] = useState({ top: 0, left: 0 });


  	useEffect(() => {
    	return () => {
    		setToggledMenu(null);
    	};
  	}, []);

	useEffect(() => {
		const handleNodes = async () => {
			setIsLoading(true)
			
			setMainGuestii(null)
			setNodesFull(indEvent.guestiis.sort((a, b) => {
              const firstCmp = a.first_name.localeCompare(b.first_name);
              if (firstCmp !== 0) return firstCmp;
              return a.last_name.localeCompare(b.last_name);
            }))

			const groupedBySource = indEvent.guestiis.sort((a, b) => {
              const firstCmp = a.first_name.localeCompare(b.first_name);
              if (firstCmp !== 0) return firstCmp;
              return a.last_name.localeCompare(b.last_name);
            }).reduce((acc, { source, main_source, _id }) => {
			  	const key = (main_source && main_source.email) ? 'admin' : source || 'admin';

			  	if (!acc[key]) acc[key] = [];
			  	acc[key].push(_id);

			  	return acc;
			}, {});

			setNodes(groupedBySource)
			setNodesOG(groupedBySource)
			setIsLoading(false)
		}

		handleNodes()
	}, [indEvent]);

	useEffect(() => {
		const handlePlusOnes = async () => {
			let plusOnesObj = {}
			for (let node of nodesFull) {
				if (node && node.plusOnes && node.plusOnes !== 0) {
					let guestiiId = node['_id'].toString()
					plusOnesObj[guestiiId] = node.plusOnes
				}
			}

			setPlusOnes(plusOnesObj)
		}

		handlePlusOnes()
	}, [nodesFull]);


	const handlePlusOnesChange = async (guestId, control) => {
	  	if (control === "-") {
			setPlusOnes(prev => {
			  	const current = prev[guestId] || 0;
			  	if (current === 0) return prev;
			  	return {
			    	...prev,
			    	[guestId]: current - 1
			  	};
			});

			setPlusOneChanges((prev) => ({
				...prev,
				[guestId]: true
			}))
	  	} else if (control === "+") {
	  		const currentPlusOnes = (plusOnes[guestId] ? plusOnes[guestId]+1 : 1) || 1
	  		if ((indEvent.capacityOG !== false) && indEvent.capacity+(currentPlusOnes) > indEvent.capacityOG) {
	  			await window.alert("This change puts you over the Guestii capacity limit you set!")
	  			return;
	  		}

			setPlusOnes((prev) => ({
			  ...prev,
			  [guestId]: (prev[guestId] || 0) + 1
			}));

			setPlusOneChanges((prev) => ({
				...prev,
				[guestId]: true
			}))
	  	} else {
	    	const capacityResponse = await axios.post(`/api/hub/update-guestii-plusones`, {
	      		event: indEvent._id,
	      		guestId: guestId,
	      		value: plusOnes[guestId],
	    	});

	    	setIndEvent((prev) => ({ ...prev, ['capacity']: capacityResponse.data.newCapacity }))

			setPlusOneChanges((prev) => ({
				...prev,
				[guestId]: false
			}))
	  	}
	};

	const handleGuestiiLink = (e, node) => {
		if (e.target.id !== "main_guestii_btn") { return; }

		if (mainGuestii && mainGuestii._id.toString() === node._id.toString()) {
			setMainGuestii(null)
			setNodes(nodesOG)
		} else {
			let guestiisInvited = indEvent.guestiis.filter(g => g.source && g.source.toString() === node._id.toString())

			if ((Object.keys(plusOnes).includes(node._id.toString()) && plusOnes[node['_id'].toString()] !== 0) || guestiisInvited.length > 0) {
				setMainGuestii(node)

				const guestiisInvitedMain = [node._id.toString(), ...guestiisInvited.map(g => g._id.toString())]
				setNodes({ admin: guestiisInvitedMain })
			}
		}
	}

	const navigateToGuestii = async () => {
		setIsLoading(true)

		const userId = localStorage.getItem("_id")
		const expiry = localStorage.getItem("expiry")
		if (!userId || !expiry) {
			locationStorage.removeItem("_id")
			locationStorage.removeItem("expiry")
			window.location = "/connect"
		}

		try {
			const retrieve = await axios.get(`/api/guestiis/get-ind-guestii/${userId}/${expiry}/${toggledMenu._id}`);
			var state = { from: retrieve.data.allGuestiis[0] };
			sessionStorage.setItem('navigationState', JSON.stringify(state));

			navigate(`/guestiis/${userId}`)
		} catch (e) {
			localStorage.removeItem("_id")
			localStorage.removeItem("expiry")
			window.location = "/connect"
		}

		setIsLoading(false)
	}


	return (
		<>
			{(!mainLoading && !isLoading)
				?
					<div
						style={{
							height: '100%',
							maxHeight: '100%',
							overflowY: 'scroll',
							position : 'relative'
						}}
						ref={containerRef}
						onClick={e => {
							if (toggledMenu) {
							    setToggledMenu(null);
							    setMenuPos({ top: 0, left: 0 });
							}
						}}
					>
						<div
							className={`${((nodes && Object.keys(nodes).length > 0) || mainLoading) && styles.table_container_indguestii} ${toggledMenu && styles.toggled_hidden_container} table_container`}
							style={(nodes && Object.keys(nodes).length > 0 && nodes["admin"].length > 0) ? { gridTemplateRows: `repeat(${Math.ceil(nodes["admin"].length / 2)}, max-content)`, marginTop: 0 } : { marginTop: 0 }}
						>
							{(nodes && Object.keys(nodes).length > 0)
								?
									<>
										{nodes["admin"].map((nodeKey, n) => {
											const groupedNode = nodes[nodeKey]
											const nodesCombined = nodesFull.filter(f => f._id.toString() === nodeKey || (groupedNode && groupedNode.includes(f._id.toString())))

											const totalRows = mainGuestii ? Math.ceil((nodes["admin"].length + 1) / 2) : Math.ceil(nodes["admin"].length / 2);
											const currentRow = Math.floor(n / 2) + 1;
											const inLastRow = currentRow === totalRows;

											return (
												<button
													className={`${styles.guestii_invited_container} ${(mainGuestii ? n !== 0 : nodesCombined.length < 2) && styles.no_pointer} ${(mainGuestii && n === 0) && styles.full_guestii_invited} ${inLastRow && styles.paddingLastItem}`}
													// style={nodesCombined.length < 2 ? { height: '115px' } : { height: `130px` }}
													onClick={(e) => handleGuestiiLink(e, nodesCombined[0])}
													id="main_guestii_btn"
												>
													{nodesCombined.slice(0, 2).map((node, innerN) => {
														const admitted = node.admitted || false

														return (
															<div
																className={`${styles.guestii_invited_ind_max} ${innerN > 0 && styles.guestii_invited_inner} ${admitted && styles.admitted_guestii_invited_ind}`}
																style={innerN > 0 ? { transform: `scale(0.${100 - (innerN * 5)})`, zIndex: 2, bottom: `-10px` } : { zIndex: 3, top: 0 }}
															>
																<div className={styles.guestii_inner_split}>
																	<div className={`${styles.guestii_profile_rounded} ${admitted && styles.admitted_profile_rounded}`}><i className={`fa-solid fa-user ${styles.s1}`}></i></div>

																	<div className={styles.guestii_profile_info}>
																		{node.invite
																			?
																				<>
																					<p className={styles.s1}>Invite Pending</p>
																					<p className={styles.xs2}>{node.value}</p>
																				</>
																			:
																				<>
																					<div className={styles.name_container}>
																						<p className={styles.s1}>{node.first_name} {node.last_name} {((!node.first_name || node.first_name === "") && (!node.last_name || node.last_name === "")) && "-"}</p>

																						{(nodesCombined.length > 2) &&
						                      												<div
																	                      		className={`${styles.leftpu_container} ${(mainGuestii ? n !== 0 : nodesCombined.length < 2) && styles.no_hover}`}
																	                      	>
																	                        	<i className={`fa-solid fa-plus ${styles.xs2}`}></i>
																	                        	<p className={styles.s1}>{nodesCombined.length-1}</p>
																	                      	</div>
																                      	}
																					</div>

																					<p className={`${styles.xs2}`}>{node.phone || "-"}</p>
																				</>
																		}
																	</div>

																	<div className={styles.top_right_modules}>
																		{(innerN !== 1) &&
													                      	<button
													                      		className={`${styles.ellipsis_container} ${(mainGuestii ? n !== 0 : nodesCombined.length < 2) && styles.no_hover}`}
																				onClick={e => {
																					e.stopPropagation();

																					if (toggledMenu && toggledMenu._id === node._id) {
																					    setToggledMenu(null);
																					    setMenuPos({ top: 0, left: 0 });
																					} else {
																						const btnRect = e.currentTarget.getBoundingClientRect();
																						const contRect = containerRef.current.getBoundingClientRect();

																						setMenuPos({
																							top: btnRect.top - contRect.top + containerRef.current.scrollTop + 20,
																							left: btnRect.left - contRect.left - 155,
																						});
																					    setToggledMenu(node);
																					}
																				}}
													                      	>
													                        	<i className={`fa-solid fa-ellipsis ${styles.m1}`}></i>
													                      	</button>
												                      	}
											                      	</div>
											                    </div>

											                    {innerN !== 1 &&
														            <div className={`${styles.widget_action_container_in} ${styles.numberInput}`}>
														                <label className={styles.s1} htmlFor={`plus-ones-${node._id.toString()}`}>
														                  	Plus-Ones:
														                </label>

														                <div className={styles.customNumberInput}>
														                	{!admitted &&
															                	<button
															                		className={`${styles.numberControl}`}
															                		onClick={() => handlePlusOnesChange(node._id.toString(), '-')}
															                	>
															                		<i className={`fa-solid fa-minus ${styles.xs2}`}></i>
															                	</button>
														                	}

														                	<input
														                		type="number"
														                		disabled={true}
														                		value={plusOnes[node._id.toString()] || 0}
														                		className={`${styles.s1}`}
														                	/>

														                	{!admitted &&
															                	<button
															                		className={`${styles.numberControl}`}
															                		onClick={() => handlePlusOnesChange(node._id.toString(), '+')}
															                	>
															                		<i className={`fa-solid fa-plus ${styles.xs2}`}></i>
															                	</button>
														                	}

														                	{plusOneChanges[node['_id'].toString()] && 
															                	<button
															                		className={`${styles.numberControl}`}
															                		onClick={() => handlePlusOnesChange(node._id.toString(), 'submit')}
															                	>
															                		<i className={`fa-solid fa-check ${styles.xs2}`}></i>
															                	</button>
														                	}
														                </div>
														            </div>
													        	}

													        	<div>
												        			<p className={`${styles.xs3} ${styles.invited_by_banner}`}>Invited by <span>{node.main_source.first_name} {node.main_source.last_name}</span></p>
												        			<p className={`${styles.xs3} ${styles.invited_by_banner}`}>{(node.tags && node.tags.length > 0) ? node.tags.map(t => t.tag).join(", ") : "-"}</p>
												        		</div>
															</div>
														)
													})}
												</button>
											)
										})}
									</>
								:
									<>
										<p className={`${styles.m1} ${styles.noResultsMain} ${styles.nrMT}`}>Use the search bar above to invite your first Guestii!</p>
									</>
							}
						</div>

                      	{(toggledMenu && !showRatings && !showTags) &&
                      		<div
                      			className={styles.toggled_menu}
							    style={{
							      position: 'absolute',
							      top: `${menuPos.top}px`,
							      left: `${menuPos.left}px`
							    }}
	                      		onClick={(e) => {
									e.preventDefault();
									e.stopPropagation();
	                      		}}
                      		>
                      			<div className={styles.toggled_header}>
                      				<i className={`fa-solid fa-gear ${styles.m1}`}></i>
                      				<p className={styles.s2}>Guestii Tools</p>
                      			</div>

		                      	<button
		                      		className={`${styles.tmenu_container}`}
		                      		onClick={(e) => {
										e.preventDefault();
										e.stopPropagation();
		                      			setShowTags(true);
		                      		}}		                      		
		                      	>
		                        	<i className={`fa-solid fa-arrow-right ${styles.s3}`}></i>
		                        	<p className={styles.s1}>Set Tags</p>
		                      	</button>

		                      	<button
		                      		className={`${styles.tmenu_container}`}
		                      		onClick={(e) => {
										e.preventDefault();
										e.stopPropagation();
		                      			setShowRatings(true);
		                      		}}
		                      	>
		                        	<i className={`fa-solid fa-arrow-right ${styles.s3}`}></i>
		                        	<p className={styles.s1}>Set Rating</p>
		                      	</button>

		                      	<button
		                      		className={`${styles.tmenu_container}`}
		                      		onClick={() => navigateToGuestii()}
		                      	>
		                        	<i className={`fa-solid fa-arrow-right ${styles.s3}`}></i>
		                        	<p className={styles.s1}>Open in Guestiis</p>
		                      	</button>

		                      	{!toggledMenu.admitted &&
			                      	<button
			                      		className={`${styles.tmenu_container}`}
			                      		onClick={(e) => {
											e.preventDefault();
											e.stopPropagation();
			                      			handleDelete(toggledMenu._id)
			                      			setToggledMenu(null)
			                      		}}
			                      	>
			                        	<i className={`fa-solid fa-arrow-right ${styles.s3}`}></i>
			                        	<p className={styles.s1}>Delete Guestii</p>
			                      	</button>
		                      	}
                      		</div>
                      	}
					</div>
				:
					<div
						style={{
							height: '100%',
							maxHeight: '100%',
							overflowY: 'scroll',
							position : 'relative'
						}}
					>
						<div className={`${styles.table_container_indguestii} table_container`} style={{ gridTemplateRows: `max-content`, marginTop: 0 }}>
							{Array.from({ length: 16 }).map((node, n) => {
								const totalRows = Math.ceil(16 / 2);
								const currentRow = Math.floor(n / 2) + 1;
								const inLastRow = currentRow === totalRows;

								return (
									<div className={`${styles.guestii_invited_ind} ${inLastRow && styles.paddingLastItem} ${styles.no_hover} shine-animation`}>
										<div className={styles.guestii_inner_split}>
											<div className={styles.guestii_profile_rounded}><i className={`fa-solid fa-user ${styles.s1}`}></i></div>

											<div className={styles.guestii_profile_info_loading}>
												<p className={styles.s1} style={{ visibility: 'hidden' }}>Example Guestii</p>
												<p className={styles.xs2} style={{ visibility: 'hidden' }}>example@guestii.app</p>
											</div>
					                    </div>

							            <div className={`${styles.widget_action_container_in} ${styles.numberInput}`} style={{ visibility: 'hidden' }}>
							                <label className={styles.xs3}>
							                  	Plus-Ones:
							                </label>

							                <div className={styles.customNumberInput}>
							                	<button
							                		className={`${styles.numberControl}`}
							                		disabled={true}
							                	>
							                		<i className={`fa-solid fa-minus ${styles.xs2}`}></i>
							                	</button>

							                	<input type="number" value={0} className={styles.xs3}/>

							                	<button
							                		className={`${styles.numberControl}`}
							                		disabled={true}
							                	>
							                		<i className={`fa-solid fa-plus ${styles.xs2}`}></i>
							                	</button>
							                </div>
							            </div>
					                </div>
					            )
					        })}
						</div>
					</div>
			}
		</>
	)
}

const TeamTableDisplay = ({ indEvent, mainLoading, handleDelete, toggledMenu, setToggledMenu, activeTeamNav, promotersPopup, setPromotersPopup, setMainGuestii, mainGuestii, setTeamFocused }) => {
	const navigate = useNavigate();
	const containerRef = useRef(null);
	const [isLoading, setIsLoading] = useState(false)
	const [nodes, setNodes] = useState([])
	const [nodesOG, setNodesOG] = useState([])
	const [plusOnes, setPlusOnes] = useState({})
	const [plusOneChanges, setPlusOneChanges] = useState({})
	const [menuPos, setMenuPos] = useState({ top: 0, left: 0 });


  	useEffect(() => {
    	return () => {
    		setToggledMenu(null);
    	};
  	}, []);

	useEffect(() => {
		const handleNodes = async () => {
			setIsLoading(true)
			
			setMainGuestii(null)
			setNodes(indEvent.team)
			setNodesOG(indEvent.team)
			setIsLoading(false)
		}

		handleNodes()
	}, [indEvent]);

	useEffect(() => {
		setIsLoading(true)

		if (nodesOG && nodesOG.length > 0) {
			let flattened;
			if (activeTeamNav.length === 0) {
				flattened = [...nodesOG]
			} else {
				flattened = [...nodesOG].filter(n => activeTeamNav.includes(n.role))
			}

			setNodes(flattened)
		}

		setIsLoading(false)
	}, [activeTeamNav.length])


	const navigateToTeam = async () => {
		setIsLoading(true)

		const userId = localStorage.getItem("_id")
		const expiry = localStorage.getItem("expiry")
		if (!userId || !expiry) {
			locationStorage.removeItem("_id")
			locationStorage.removeItem("expiry")
			window.location = "/connect"
		}

		try {
			const retrieve = await axios.get(`/api/team/get-ind-team-members/${userId}/${expiry}/${toggledMenu._id}`);
			var state = { from: retrieve.data.teamMember };
			sessionStorage.setItem('navigationState', JSON.stringify(state));

			navigate(`/team/${userId}`)
		} catch (e) {
			localStorage.removeItem("_id")
			localStorage.removeItem("expiry")
			window.location = "/connect"
		}

		setIsLoading(false)
	}


	return (
		<>
			{(!mainLoading && !isLoading)
				?
					<div
						style={{
							height: '100%',
							maxHeight: '100%',
							overflowY: 'scroll',
							position : 'relative'
						}}
						ref={containerRef}
						onClick={e => {
							if (toggledMenu) {
							    setToggledMenu(null);
							    setMenuPos({ top: 0, left: 0 });
							}
						}}
					>
						<div
							className={`${((nodes && nodes.length > 0) || mainLoading) && styles.table_container_indguestii} ${toggledMenu && styles.toggled_hidden_container} table_container`}
							style={(nodes && nodes.length > 0) ? { gridTemplateRows: `repeat(${Math.ceil(nodes.length / 2)}, max-content)` } : {}}
						>
							{(nodes && nodes.length > 0)
								?
									<>
										{nodes.map((node, n) => {
											const totalRows = mainGuestii ? Math.ceil((nodes.length + 1) / 2) : Math.ceil(nodes.length / 2);
											const currentRow = Math.floor(n / 2) + 1;
											const inLastRow = currentRow === totalRows;

											return (
												<button
													className={`${styles.guestii_invited_container} ${(mainGuestii && n === 0) && styles.full_guestii_invited} ${node.role !== "Promoter" && styles.no_pointer} ${inLastRow && styles.paddingLastItem}`}
													// onClick={(e) => handleGuestiiLink(e, nodesCombined[0])}
													id="main_guestii_btn"
												>
													<div
														className={`${styles.guestii_invited_ind}`}
														style={{ zIndex: 3, top: 0 }}
													>
														<div className={styles.guestii_inner_split}>
															<div className={`${styles.guestii_profile_rounded}`}><i className={`fa-solid fa-${node.role === "SuperAdmin" ? "user" : node.role === "Event Manager" ? "calendar-days" : node.role === "Promoter" ? "envelope" : "qrcode"} ${styles.m1}`}></i></div>
															<div className={styles.guestii_profile_info}>
																<p className={styles.s1}>{node.first_name} {node.last_name} {((!node.first_name || node.first_name === "") && (!node.last_name || node.last_name === "")) && "-"}</p>
																<p className={`${styles.xs2}`}>{node.email}</p>
															</div>

									                      	<button
									                      		className={`${styles.ellipsis_container}`}
																onClick={e => {
																	e.stopPropagation();

																	if (toggledMenu && toggledMenu._id === node._id) {
																	    setToggledMenu(null);
																	    setMenuPos({ top: 0, left: 0 });
																	} else {
																		const btnRect = e.currentTarget.getBoundingClientRect();
																		const contRect = containerRef.current.getBoundingClientRect();

																		setMenuPos({
																			top: btnRect.top - contRect.top + containerRef.current.scrollTop + 20,
																			left: btnRect.left - contRect.left - 155,
																		});
																	    setToggledMenu(node);
																	}
																}}
									                      	>
									                        	<i className={`fa-solid fa-ellipsis ${styles.m1}`}></i>
									                      	</button>
														</div>

														<p className={`${styles.s1} ${styles.role_tag}`}>{node.role} {node.role === "Promoter" && <span>(+{node.limit})</span>}</p>
													</div>
												</button>
											)
										})}
									</>
								:
									<>
										<p className={`${styles.m1} ${styles.noResultsMain} ${styles.nrMTT}`}>Use the search bar above to invite your first Team Member!</p>
									</>
							}
						</div>

                      	{(toggledMenu && !promotersPopup) &&
                      		<div
                      			className={styles.toggled_menu}
							    style={{
							      position: 'absolute',
							      top: `${menuPos.top}px`,
							      left: `${menuPos.left}px`
							    }}
	                      		onClick={(e) => {
									e.preventDefault();
									e.stopPropagation();
	                      		}}
                      		>
                      			<div className={styles.toggled_header}>
                      				<i className={`fa-solid fa-gear ${styles.m1}`}></i>
                      				<p className={styles.s2}>Team Tools</p>
                      			</div>

                      			{toggledMenu.role === "Promoter" &&
			                      	<button
			                      		className={`${styles.tmenu_container}`}
			                      		onClick={(e) => {
											e.preventDefault();
											e.stopPropagation();
			                      			setPromotersPopup([{...toggledMenu, edit: true}]);
			                      		}}		                      		
			                      	>
			                        	<i className={`fa-solid fa-arrow-right ${styles.s3}`}></i>
			                        	<p className={styles.s1}>Set Limit</p>
			                      	</button>
		                      	}

		                      	<button
		                      		className={`${styles.tmenu_container}`}
		                      		onClick={() => navigateToTeam()}
		                      	>
		                        	<i className={`fa-solid fa-arrow-right ${styles.s3}`}></i>
		                        	<p className={styles.s1}>Open in Team</p>
		                      	</button>

		                      	<button
		                      		className={`${styles.tmenu_container}`}
		                      		onClick={(e) => {
										e.preventDefault();
										e.stopPropagation();
		                      			handleDelete(toggledMenu._id)
		                      			setTeamFocused(false)
		                      			setToggledMenu(null)
		                      		}}
		                      	>
		                        	<i className={`fa-solid fa-arrow-right ${styles.s3}`}></i>
		                        	<p className={styles.s1}>Delete Member</p>
		                      	</button>
                      		</div>
                      	}
					</div>
				:
					<div
						style={{
							height: '100%',
							maxHeight: '100%',
							overflowY: 'scroll',
							position : 'relative'
						}}
					>
						<div className={`${styles.table_container_indguestii} table_container`} style={{ gridTemplateRows: `max-content` }}>
							{Array.from({ length: 16 }).map((node, n) => {
								const totalRows = Math.ceil(16 / 2);
								const currentRow = Math.floor(n / 2) + 1;
								const inLastRow = currentRow === totalRows;

								return (
									<div className={`${styles.guestii_invited_ind} ${inLastRow && styles.paddingLastItem} ${styles.no_hover} shine-animation`}>
										<div className={styles.guestii_inner_split}>
											<div className={styles.guestii_profile_rounded}><i className={`fa-solid fa-user ${styles.s1}`}></i></div>

											<div className={styles.guestii_profile_info_loading}>
												<p className={styles.s1} style={{ visibility: 'hidden' }}>Example Guestii</p>
												<p className={styles.xs2} style={{ visibility: 'hidden' }}>example@guestii.app</p>
											</div>
					                    </div>
					                </div>
					            )
					        })}
						</div>
					</div>
			}
		</>
	)
}


const TableDisplay = ({ indEvent, handleDelete, isTeam, mainLoading, isFocused, mainGuestii, setMainGuestii }) => {
	const eventID = indEvent._id
	const [isLoading, setIsLoading] = useState(false)
	const [columns, setColumns] = useState(["Name", "Email", "Phone", "Actions"]);
	const [gridLayout, setGridLayout] = useState("minmax(0px, 1fr) minmax(0px, 2fr) minmax(0px, 1fr) minmax(0px, 1fr)");
	const tableDataRef = useRef(null);
	const [plusOnes, setPlusOnes] = useState({});
	const [plusOneChanges, setPlusOneChanges] = useState({})
	const [nodes, setNodes] = useState([])
	const [nodesOG, setNodesOG] = useState([])


	useEffect(() => {
		const handleNodes = async () => {
			let indEventDup = {...indEvent}

			let nodesArr = []
			if (isTeam) {
				nodesArr = indEventDup.team.map((t, i) => {
			    	return {
			     		_id: t._id,
			     		 id: i+1,
			      		first_name: t.first_name,
			      		last_name: t.last_name,
			      		email: t.email,
			      		phone: t.phone,
			      		role: t.role.name,
			    	};
			  	});
				
			} else {
				nodesArr = indEventDup.guestiis.map((guestii, i) => {
				    return {
				      	...guestii,
				      	_id: guestii._id,
				      	id: i+1,
				      	first_name: guestii.first_name,
				      	last_name: guestii.last_name,
				      	phone: guestii.phone,
				      	plusOnes: guestii.plusOnes || 0
				    };
				})
			}

			setNodes(nodesArr)
			setNodesOG(nodesArr)
		}

		handleNodes()
	}, [indEvent]);

	const setTableDataHeight = () => {
		const tableContainer = document.querySelector('.table_container');
		const tableDataContainer = tableDataRef.current;

		if (tableContainer && tableDataContainer) {
	  		const tableContainerHeight = tableContainer.clientHeight;
	  		const siblingsHeight = Array.from(tableDataContainer.parentNode.children).filter(child => child !== tableDataContainer).reduce((acc, child) => acc + child.clientHeight, 0);

	  		tableDataContainer.style.height = `${tableContainerHeight - siblingsHeight - 60}px`;
		}
	};

	useEffect(() => {
		const handleResize = async () => {
			setTableDataHeight();
			window.addEventListener('resize', setTableDataHeight);

			return () => {
		  		window.removeEventListener('resize', setTableDataHeight);
			};
		}

		handleResize()
	}, []);

	useEffect(() => {
		const handlePlusOnes = async () => {
			if (!isTeam) {
				let plusOnesObj = {}

				for (let node of nodes) {
					if (node && node.plusOnes && node.plusOnes !== 0) {
						let guestiiId = node['_id'].toString()
						plusOnesObj[guestiiId] = node.plusOnes
					}
				}

				setPlusOnes(plusOnesObj)
			}
		}

		setIsLoading(true)
		handlePlusOnes()
		setIsLoading(false)
	}, [nodesOG]);

	const handlePlusOnesChange = async (guestId, control) => {
	  	if (control === "-") {
			setPlusOnes(prev => {
			  	const current = prev[guestId] || 0;
			  	if (current === 0) return prev;
			  	return {
			    	...prev,
			    	[guestId]: current - 1
			  	};
			});

			setPlusOneChanges((prev) => ({
				...prev,
				[guestId]: true
			}))
	  	} else if (control === "+") {
	  		const currentPlusOnes = plusOnes[guestId] || 0
	  		if ((indEvent.capacityOG !== false) && indEvent.capacity+(currentPlusOnes+1) > indEvent.capacityOG) {
	  			await window.alert("This change puts you over the Guestii capacity limit you set!")
	  			return;
	  		}

			setPlusOnes((prev) => ({
			  ...prev,
			  [guestId]: (prev[guestId] || 0) + 1
			}));

			setPlusOneChanges((prev) => ({
				...prev,
				[guestId]: true
			}))
	  	} else {
	    	const response = await axios.post(`/api/hub/update-guestii-plusones`, {
	      		event: indEvent._id,
	      		guestId: guestId,
	      		value: plusOnes[guestId],
	    	});

	    	setIndEvent((prev) => ({ ...prev, ['capacity']: capacityResponse.data.newCapacity }))

			setPlusOneChanges((prev) => ({
				...prev,
				[guestId]: false
			}))
	  	}
	};

	const handleGuestiiLink = (e, node) => {
		if (e.target.id !== "main_guestii_btn" && e.target.id !== "node_guestii_btn") { return; }

		if (mainGuestii && mainGuestii._id.toString() === node._id.toString()) {
			setMainGuestii(null)
			setNodes(nodesOG)
		} else {
			let guestiisInvited = indEvent.guestiis.filter(g => g.source && g.source.toString() === node._id.toString())

			if ((Object.keys(plusOnes).includes(node._id.toString()) && plusOnes[node['_id'].toString()] !== 0) || guestiisInvited.length > 0) {
				setMainGuestii(node)
				setNodes(guestiisInvited)
			} else {
				let guestiiLink = node.source

				if (guestiiLink) {
					let guestiiMain = indEvent.guestiis.find(g => g._id.toString() === guestiiLink.toString())
					let guestiisInvited = indEvent.guestiis.filter(g => g.source && g.source.toString() === guestiiLink.toString())

					setMainGuestii(guestiiMain)
					setNodes(guestiisInvited)
				}
			}
		}
	}

	return (
		<>
			{((!mainLoading && !isLoading) && mainGuestii) &&
				<button id="main_guestii_btn" className={`${styles.guestii_invited_ind} ${mainGuestii.admitted && styles.admitted_guestii_invited_ind} ${styles.main_guestii}`} onClick={(e) => handleGuestiiLink(e, mainGuestii)} disabled={mainGuestii.admitted}>
					<div className={styles.guestii_inner_split}>
						<div className={styles.guestii_profile_rounded}><i className={`fa-solid fa-user ${styles.s1}`}></i></div>

						<div className={styles.guestii_profile_info}>
							{mainGuestii.invite
								?
									<>
										<p className={styles.s1}>Invite Pending</p>
										<p className={styles.xs2}>{mainGuestii.value}</p>
									</>
								:
									<>
										<p className={styles.s1}>{mainGuestii.first_name} {mainGuestii.last_name}</p>
										<p className={styles.xs2}>{mainGuestii.phone || "-"}</p>
									</>
							}
						</div>
					</div>

		            <div className={`${styles.widget_action_container_in} ${styles.numberInput}`}>
		                <label className={styles.xs3} htmlFor={`plus-ones-main-${mainGuestii._id.toString()}`}>
		                  	Plus-Ones:
		                </label>

		                <div className={styles.customNumberInput}>
		                	{!mainGuestii.admitted &&
			                	<button
			                		className={`${styles.numberControl}`}
			                		onClick={() => handlePlusOnesChange(mainGuestii._id.toString(), '-')}
			                	>
			                		<i className={`fa-solid fa-minus ${styles.xs2}`}></i>
			                	</button>
		                	}

		                	<input type="number" disabled={mainGuestii.admitted} value={plusOnes[mainGuestii._id.toString()] || 0} className={styles.xs3}/>

		                	{!mainGuestii.admitted &&
			                	<button
			                		className={`${styles.numberControl}`}
			                		onClick={() => handlePlusOnesChange(mainGuestii._id.toString(), '+')}
			                	>
			                		<i className={`fa-solid fa-plus ${styles.xs2}`}></i>
			                	</button>
		                	}

		                	{plusOneChanges[mainGuestii['_id'].toString()] && 
			                	<button
			                		className={`${styles.numberControl}`}
			                		onClick={() => handlePlusOnesChange(mainGuestii._id.toString(), 'submit')}
			                	>
			                		<i className={`fa-solid fa-check ${styles.xs2}`}></i>
			                	</button>
		                	}
		                </div>
		            </div>
			    </button>
			}

			{(mainLoading || isLoading)
				?
					<div className={`${((nodes && nodes.length > 0) || mainLoading) && styles.table_container_indguestii} table_container`} style={{ gridTemplateRows: `max-content)` }}>
						{Array.from({ length: 12 }).map((node, n) => {
							const totalRows = Math.ceil(12 / 2);
							const currentRow = Math.floor(n / 2) + 1;
							const inLastRow = currentRow === totalRows;

							return (
								<div className={`${styles.guestii_invited_ind} ${inLastRow && styles.paddingLastItem} shine-animation`}>
									<div className={styles.guestii_inner_split}>
										<div className={styles.guestii_profile_rounded}><i className={`fa-solid fa-user ${styles.s1}`}></i></div>

										<div className={styles.guestii_profile_info_loading}>
											<p className={styles.s1} style={{ visibility: 'hidden' }}>Example Guestii</p>
											<p className={styles.xs2} style={{ visibility: 'hidden' }}>example@guestii.app</p>
										</div>
				                    </div>

				                    {!isTeam &&
							            <div className={`${styles.widget_action_container_in} ${styles.numberInput}`} style={{ visibility: 'hidden' }}>
							                <label className={styles.xs3}>
							                  	Plus-Ones:
							                </label>

							                <div className={styles.customNumberInput}>
							                	<button
							                		className={`${styles.numberControl}`}
							                		disabled={true}
							                	>
							                		<i className={`fa-solid fa-minus ${styles.xs2}`}></i>
							                	</button>

							                	<input type="number" value={0} className={styles.xs3}/>

							                	<button
							                		className={`${styles.numberControl}`}
							                		disabled={true}
							                	>
							                		<i className={`fa-solid fa-plus ${styles.xs2}`}></i>
							                	</button>
							                </div>
							            </div>
						            }
				                </div>
				            )
				        })}
					</div>
				:
					<div className={`${((nodes && nodes.length > 0) || mainLoading) && styles.table_container_indguestii} table_container`} style={{ gridTemplateRows: `repeat(${Math.ceil(nodes.length / 2)}, max-content)` }}>
						{(nodes && nodes.length > 0)
							?
								<>
									{nodes.map((node, n) => {
										const totalRows = Math.ceil(nodes.length / 2);
										const currentRow = Math.floor(n / 2) + 1;
										const inLastRow = currentRow === totalRows;
										const admitted = node.admitted || false

										return (
											<button id="node_guestii_btn" className={`${styles.guestii_invited_ind} ${admitted && styles.admitted_guestii_invited_ind} ${inLastRow && styles.paddingLastItem}`} onClick={(e) => handleGuestiiLink(e, node)} disabled={admitted}>
												<div className={styles.guestii_inner_split}>
													<div className={`${styles.guestii_profile_rounded} ${admitted && styles.admitted_profile_rounded}`}><i className={`fa-solid fa-user ${styles.s1}`}></i></div>

													<div className={styles.guestii_profile_info}>
														{node.invite
															?
																<>
																	<p className={styles.s1}>Invite Pending</p>
																	<p className={styles.xs2}>{node.value}</p>
																</>
															:
																<>
																	<p className={styles.s1}>{node.first_name} {node.last_name}</p>
																	<p className={styles.xs2}>{node.phone || "-"}</p>
																</>
														}
														
														
													</div>

													{!admitted &&
								                      	<button className={`${styles.medal_container}`} onClick={() => handleDelete(node)}>
								                        	<i className={`fa-solid fa-trash-can`}></i>
								                      	</button>
							                      	}
							                    </div>

							                    {isTeam
							                    	?
											            <div className={`${styles.widget_action_container_in} ${styles.numberInput}`}>
											            	<p className={styles.s1}>{node.role}</p>
											            </div>
							                    	:
											            <div className={`${styles.widget_action_container_in} ${styles.numberInput}`}>
											                <label className={styles.xs3} htmlFor={`plus-ones-${node._id.toString()}`}>
											                  	Plus-Ones:
											                </label>

											                <div className={styles.customNumberInput}>
											                	{!admitted &&
												                	<button
												                		className={`${styles.numberControl}`}
												                		onClick={() => handlePlusOnesChange(node._id.toString(), '-')}
												                	>
												                		<i className={`fa-solid fa-minus ${styles.xs2}`}></i>
												                	</button>
											                	}

											                	<input type="number" disabled={admitted} value={plusOnes[node._id.toString()] || 0} className={styles.xs3}/>

											                	{!admitted &&
												                	<button
												                		className={`${styles.numberControl}`}
												                		onClick={() => handlePlusOnesChange(node._id.toString(), '+')}
												                	>
												                		<i className={`fa-solid fa-plus ${styles.xs2}`}></i>
												                	</button>
											                	}

											                	{plusOneChanges[node['_id'].toString()] && 
												                	<button
												                		className={`${styles.numberControl}`}
												                		onClick={() => handlePlusOnesChange(node._id.toString(), 'submit')}
												                	>
												                		<i className={`fa-solid fa-check ${styles.xs2}`}></i>
												                	</button>
											                	}
											                </div>
											            </div>
							                	}
											</button>
										)
									})}
								</>
							:
								<>
									{isTeam &&<p className={`${styles.m1} ${styles.noResultsMain} ${styles.nrMT}`}>Use the search bar above to invite your first team member!</p>}
								</>
						}
					</div>
			}
		</>
	)
}

const IndEventPage = ({ indEvent, setIndEvent, handleOpen, teamMembers, setTeamMembers, teamMembersOG, showRatings, setShowRatings, toggledMenu, setToggledMenu, showTags, setShowTags, setPromotersPopup, promotersPopup, teamSearchTerm, setTeamSearchTerm, teamFocused, setTeamFocused }) => {
  	const [guestiiSearchTerm, setGuestiiSearchTerm] = useState("");
  	const [filteredUsers, setFilteredUsers] = useState([]);
  	const [filteredTeam, setFilteredTeam] = useState([])
  	const [indEventNav, setIndEventNav] = useState("Dashboard")
  	const [activeChannel, setActiveChannel] = useState("Guestiis")
  	const [announcementMsg, setAnnouncementMsg] = useState("")
  	const [mainLoading, setMainLoading] = useState(false)
  	const [isFocused, setIsFocused] = useState(false)
  	const [showTemplates, setShowTemplates] = useState(false)
  	const fileInputRef = useRef(null);
  	const [fileUploading, setFileUploading] = useState(false)
  	const [validationError, setValidationError] = useState(null)
  	const [showMenu, setShowMenu] = useState(false)
  	const [mainGuestii, setMainGuestii] = useState(null)
  	const [searchableTeamMembers, setSearchableTeamMembers] = useState([])
  	const [activeTeamNav, setActiveTeamNav] = useState([])
	const [nodes, setNodes] = useState({})
	const [nodesOG, setNodesOG] = useState({})
	const [nodesFull, setNodesFull] = useState([])

	useEffect(() => {
		setMainLoading(true)

		setSearchableTeamMembers([])
		const eventTeamMembers = indEvent.team.map(t => t._id.toString())
		const availableMembers = teamMembers.filter(t => t.role.name !== "SuperAdmin" && !eventTeamMembers.includes(t._id.toString()))
		setSearchableTeamMembers(availableMembers)

		setMainLoading(false)
	}, [indEventNav, indEvent])

  	useEffect(() => {
  		if (indEvent) {
  			if (indEvent.guestiis && indEvent.guestiis.length > 0) {
  				setIndEventNav("Dashboard")
  			} else {
  				setIndEventNav("Guestiis")
  			}
  		}
  	}, [])

  	useEffect(() => {
  		if (isFocused) {
  			setMainGuestii(null)
  		}
  	}, [isFocused])

	useEffect(() => {
		if (validationError) {
		  	const timer = setTimeout(() => setValidationError(null), 2000);
		  	return () => clearTimeout(timer);
		}
	}, [validationError]);

	const handleIndEventNav = async (nav) => {
		setIndEventNav(nav)
		setMainGuestii(null)
		setSearchableTeamMembers([])
		setMainLoading(false)
	}

	function formatDate(dateString) {
	    const date = new Date(dateString);

	    const days = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
	    const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

	    const day = days[date.getDay()];
	    const dateNumber = date.getDate();
	    const month = months[date.getMonth()];

	    const suffix =
	        dateNumber % 10 === 1 && dateNumber !== 11
	            ? 'st'
	            : dateNumber % 10 === 2 && dateNumber !== 12
	            ? 'nd'
	            : dateNumber % 10 === 3 && dateNumber !== 13
	            ? 'rd'
	            : 'th';

	    return `${day}, ${dateNumber}${suffix} ${month}`;
	}

	function formatTime(dateString) {
	  const date = new Date(dateString);

	  const hours   = date.getHours();
	  const minutes = String(date.getMinutes()).padStart(2, '0');

	  return `${hours}:${minutes}`;
	}


	function convertTo24HourTime(isoString) {
	    const date = new Date(isoString);
	    const time = date.toLocaleTimeString('en-GB', { hour: '2-digit', minute: '2-digit' });

	    return time;
	}

	function objectsEqualCustom(array, targetObject, keyToIgnore) {
	    const areEqual = array.some((obj) => {
	        const filteredObj = { ...obj };
	        const filteredTarget = { ...targetObject };

	        delete filteredObj[keyToIgnore];
	        delete filteredTarget[keyToIgnore];

	        return JSON.stringify(filteredObj) === JSON.stringify(filteredTarget);
	    });

	    return areEqual
	}

	function normalizePhone(input) {
	  	const digits = input.replace(/\D+/g, '');

	  	if (digits.startsWith('04') && digits.length === 10) {
	    	return '+61' + digits.slice(1);
	  	}

	  	if (digits.startsWith('61') && digits.length === 11) {
	    	return '+'.concat(digits);
	  	}

	  	if (digits.length === 9 && digits.startsWith('4')) {
	    	return '+61' + digits;
	  	}

	  	return null;
	}

	function isValidPhone(input) {
	  	return normalizePhone(input) !== null;
	}

  	const handleGuestiiSearch = async (searchTerm=null, results=null) => {
		function splitLabelsAndTags(data) {
		  	const terms = [];
		  	const tagMap = {};
		  	const LINE_RE = /^\s*(.*?)\s*(?:\((.*?)\))?\s*$/;

		  	for (const entry of data) {
		    	const match = LINE_RE.exec(entry);
		    	if (!match) {
		      		continue;
		    	}

		    	const label = match[1];
		    	terms.push(label);

		    	const tags = match[2] ? match[2].split(",").map(t => t.trim()).filter(t => t.length) : [];
		    	tagMap[label] = tags;
		  	}

		  	return { terms, tagMap };
		}

  		const userId = localStorage.getItem('_id');

		const raw = (searchTerm ?? guestiiSearchTerm).split(/\r?\n/).map(s => s.trim().replace(/\s+/g, ' ')).filter(Boolean);
		const seen = new Map();
		for (const item of raw) {
		  const key = item.toLowerCase();
		  if (!seen.has(key)) seen.set(key, item);
		}

		const rawTerms = Array.from(seen.values());
		const { terms, tagMap } = splitLabelsAndTags(rawTerms);

		if (terms.length === 0) {
			setValidationError(true);
			return;
		}

		setMainLoading(true)

		// 2. Build a map of existing guests by phone
		const existingMap = new Map();
		indEvent.guestiis.forEach(g => {
			if (g.phone) {
				let key = g.phone
				if (key) existingMap.set(key, g);
			} else {
				let key = `${g.first_name} ${g.last_name}`
				existingMap.set(key.toLowerCase(), g);
			}
		});

  		// 3. Prepare arrays for immediate results vs name‐lookups
  		let filteredGuestiiUsers = [];
  		const nameLookups = [];

 		 for (const term of terms) {
 		 	const norm = normalizePhone(term);
 		 	const result = results?.find(r => r.value === norm)
 		 	const plusOnes = result?.plusOnes || 0
 		 	const tags = result ? result.tags : tagMap ? tagMap[term] : []

    		// A) If it matches an existing guest → mark exists
    		if (norm && existingMap.has(norm)) {
      			filteredGuestiiUsers.push({
        			value: norm,
        			phone: norm,
        			exists: true,
        			plusOnes: plusOnes,
        			tags: tags
      			});

      			continue;
    		}

    		if (norm) {
      			filteredGuestiiUsers.push({
        			value: norm,
        			phone: norm,
        			valid: true,
        			plusOnes: plusOnes,
        			tags: tags
      			});

      			continue;
    		} else {
    			if (existingMap.has(term)) {
	      			filteredGuestiiUsers.push({
	        			value: term,
	        			phone: term,
	        			exists: true,
	        			plusOnes: plusOnes,
	        			tags: tags
	      			});	
    			}
    		}

		    nameLookups.push({
		      	term,
		      	plusOnes: plusOnes,
		      	tags: tags
		    });
		}


  		// 4. Fire off all name lookups in parallel
  		await Promise.all(nameLookups.map(async ({ term, plusOnes, tags }) => {
		    try {
		      	const resp = await axios.post(`/api/hub/check-guestii-by-name/${userId}`, { name: term });
	  			const matches = resp.data.guestiiNameMatch || [];

	  			matches.forEach(m => {
	    			const mPhone = normalizePhone(m.phone);

	    			if (mPhone && !existingMap.has(mPhone)) {
	      				filteredGuestiiUsers.push({
	        				value: `${m.first_name} ${m.last_name}`.trim(),
	        				phone: mPhone,
	        				valid: true,
	        				_id: m._id,
	        				plusOnes,
	        				tags
	      				});
	    			} else {
	    				filteredGuestiiUsers.push({ value: term, valid: false, plusOnes, tags });
	    			}
	  			});
	  			
	  			// If no name matches at all, it’s invalid
				if (matches.length === 0) {
					filteredGuestiiUsers.push({ value: term, valid: false, plusOnes, tags });
				}
    		} catch (err) {
      			console.error('Name lookup failed for', term, err);
      			// On error, mark as invalid so user sees feedback
      			filteredGuestiiUsers.push({ value: term, valid: false, plusOnes, tags });
    		}
  		}));


		filteredGuestiiUsers = Array.from(
		  	new Map(filteredGuestiiUsers.map(u => [u.value, u])).values()
		);

    	const response = await axios.post(`/api/hub/check-guestii-invite-duplicates`, {
      		fieldsToCheck: filteredGuestiiUsers
    	});
    	const checkedFilteredGuestiis = response.data.fieldsChecked

		checkedFilteredGuestiis.sort((a, b) => {
			if (a.exists === b.exists) return 0;
			return a.valid ? 1 : -1
		})

  		if ((indEvent.capacityOG !== false) && indEvent.capacity+(checkedFilteredGuestiis.length) > indEvent.capacityOG) {
  			setValidationError(true)
  			await window.alert("This change puts you over the Guestii capacity limit you set!")
  			return;
  		}

  		if (checkedFilteredGuestiis.length === 0) {
  			setValidationError(true)
  		}

  		setFilteredUsers(checkedFilteredGuestiis)
  		setMainLoading(false)
  	};

  	const handleFilteredUsersPlusOnes = async (user, control) => {
  		let filteredUsersDup = [...filteredUsers]
  		const filteredUserFound = filteredUsersDup.find(f => (f._id && user._id) ? f._id.toString() === user._id.toString() : f.value === user.value)
  		const filteredUserIndex = filteredUsersDup.indexOf(filteredUserFound)

  		if (control === "+") {
  			filteredUsersDup[filteredUserIndex]['plusOnes'] += 1
	  		const currentPlusOnes = filteredUsersDup.reduce((sum, { plusOnes }) => sum + (Number(plusOnes) || 0), 0);

	  		if ((indEvent.capacityOG !== false) && indEvent.capacity+(currentPlusOnes+filteredUsersDup.length) > indEvent.capacityOG) {
	  			filteredUsersDup[filteredUserIndex]['plusOnes'] -= 1
	  			await window.alert("This change puts you over the Guestii capacity limit you set!")
	  			return;
	  		}
  		} else {
  			if (filteredUsersDup[filteredUserIndex]['plusOnes'] !== 0) {
  				filteredUsersDup[filteredUserIndex]['plusOnes'] -= 1
  			}
  		}

  		setFilteredUsers(filteredUsersDup)
  	}

  	const handleTeamSearch = (members) => {
  		setTeamSearchTerm(members)
  	}

  	const handleGuestiiInviteList = async (sel) => {
  		const userId = localStorage.getItem('_id');
    	setGuestiiSearchTerm("");
    	setFilteredUsers([]);
    	setGuestiiSearchTerm("");
    	setIsFocused(false)

    	setMainLoading(true)

    	const newEvent = await axios.post(`/api/hub/invite-new-guestii/${userId}`, {
      		event: indEvent._id,
      		value: sel._id ? sel._id : sel.value,
      		plusOnes: sel.plusOnes,
      		valid: sel.valid,
      		tags: sel.tags
    	});

    	setIndEvent(newEvent.data.newEvent)
    	setMainLoading(false)
  	}

  	const handleGuestiiInviteListBulk = async () => {
  		const userId = localStorage.getItem('_id');
  		const validSubmissions = filteredUsers.filter(u => !u.exists && !u.exists_externally)

    	setFilteredUsers([]);
    	setGuestiiSearchTerm("");
    	setIsFocused(false)

    	setMainLoading(true)
    	const newEvent = await axios.post(`/api/hub/invite-new-guestii-bulk/${userId}`, {
      		event: indEvent._id,
      		values: validSubmissions,
    	});

    	setIndEvent(newEvent.data.newEvent)
    	setMainLoading(false)
  	}

  	const handleDeleteGuestii = async (sel) => {
  		const confirmDel = await window.confirm("Are you sure you want to delete this Guestii, and their plus ones from this event?")

  		if (confirmDel) {
	    	let indEventDup = { ...indEvent }
	    	let indEventGuestiis = [...indEventDup.guestiis]
			let filteredGuestiis = indEventGuestiis.filter(g => {
				let notGuestii = g._id.toString() !== sel.toString()
				let notGuestiiPlusOne = (g.source ? g.source.toString() !== sel : true)

				return (notGuestii && notGuestiiPlusOne)
			})

	    	indEventDup['guestiis'] = filteredGuestiis
	    	setIndEvent(indEventDup)

		    const newEvent = await axios.post(`/api/hub/delete-guestii`, {
		      event: indEvent._id,
		      deleteId: sel
		    });

		    setIndEvent((prev) => ({...prev, ['capacity']: newEvent.data.newEvent.capacity}))

	    	setGuestiiSearchTerm("");
	    	setFilteredUsers([]);
  		}
  	}

  	const handleTeamList = async () => {
  		if (teamSearchTerm.length === 0) {
  			setValidationError(true)
  			return;
  		}

  		if (teamSearchTerm.filter(t => t.role === "Promoter").length > 0) {
  			setPromotersPopup(teamSearchTerm.filter(t => t.role === "Promoter"))
  			return;
  		}

  		setTeamFocused(false)
    	setTeamSearchTerm([]);
    	setMainLoading(true)

    	const userId = localStorage.getItem('_id');
    	const newEvent = await axios.post(`/api/hub/invite-new-team/${userId}`, {
      		event: indEvent._id,
      		values: teamSearchTerm,
    	});

    	setIndEvent(newEvent.data.newEvent)
    	setMainLoading(false)
  	}

  	const handleDeleteTeam = async (sel) => {
  		const confirmDel = await window.confirm("Are you sure you want to delete this team member from this event?")

  		if (confirmDel) {
  			setMainLoading(true)
	    	let indEventDup = { ...indEvent }
	    	let indEventTeam = [...indEventDup.team]
	    	let filteredTeam = indEventTeam.filter(g => g._id.toString() !== sel.toString())
	    	indEventDup['team'] = filteredTeam
	    	setIndEvent(indEventDup)

		    await axios.post(`/api/hub/delete-team`, {
		      event: indEvent._id,
		      id: sel,
		    });

		    setMainLoading(false)
  		}
  	}

	function sortByDateTime(data) {
	    const now = new Date();
	    const dataSorted = data.sort((a, b) => new Date(a.date) - new Date(b.date));

	    return [...dataSorted.reverse()];
	}

	const generateQuickId = () => {
		const now = new Date();
		const timestamp = now.getTime();
		const random = Math.floor(Math.random() * 10000);

		return `${timestamp}-${random}`;
	};

  	const handleAnnouncementMsg = (term) => {
  		setAnnouncementMsg(term)
  	}

  	const sendAnnouncement = async () => {
    	let indEventDup = { ...indEvent }
    	let existingChannel = { ...indEventDup['announcements'] }
    	let idGenerated = generateQuickId()

		if (existingChannel[activeChannel.toLowerCase()] && Array.isArray(existingChannel[activeChannel.toLowerCase()])) {
			existingChannel[activeChannel.toLowerCase()].push({
				id: idGenerated,
				msg: announcementMsg,
				date: new Date()
			})
		} else {
			existingChannel[activeChannel.toLowerCase()] = [{
				id: idGenerated,
				msg: announcementMsg,
				date: new Date()
			}]
		}

		indEventDup['announcements'] = existingChannel
		setIndEvent(indEventDup)

	    await axios.post(`/api/hub/send-announcement`, {
	    	id: idGenerated,
	      	event: indEvent._id,
	      	channel: activeChannel,
	      	msg: announcementMsg,
	    });

	    setAnnouncementMsg("")
  	}

  	const deleteAnnouncement = async (id) => {
    	let indEventDup = { ...indEvent }
    	let existingChannel = { ...indEventDup['announcements'] }

    	let channelFiltered = existingChannel[activeChannel.toLowerCase()].filter(msgData => msgData.id !== id)
    	existingChannel[activeChannel.toLowerCase()] = channelFiltered

		indEventDup['announcements'] = existingChannel
		setIndEvent(indEventDup)

	    await axios.post(`/api/hub/delete-announcement`, {
	      	event: indEvent._id,
	      	channel: activeChannel,
	      	id: id,
	    });
  	}

 
  	const handleDownloadTemplate = async (control) => {
  		const userId = localStorage.getItem('_id');

    	let url;
  		switch (control) {
	  		case 'xlsx':
	  			url = `/api/hub/templates/${userId}/xlsx`
	  			break;
	  		case 'csv':
	  			url = `/api/hub/templates/${userId}/csv`
	  			break;
  		}

	    
	    const response = await axios.get(url, { responseType: 'blob' });

	    const blob = new Blob([response.data], { type: 'application/pdf' });
	    const pdfUrl = URL.createObjectURL(blob);

	    const link = document.createElement('a');
	    link.href = pdfUrl;
	    link.setAttribute('download', `guestii-upload-template.${control}`);
	    document.body.appendChild(link);
	    link.click();
	    document.body.removeChild(link);

	    setTimeout(() => { URL.revokeObjectURL(pdfUrl) }, 100);
  		setShowTemplates(false)
  	}

	const handleFileChange = async (event) => {
		const userId = localStorage.getItem('_id');
		const file = event.target.files[0];

		if (file) {
			setFileUploading(true)

			const formData = new FormData();
			formData.append('file', file);

			try {
				const response = await axios.post(`/api/hub/bulk-upload/${userId}`, formData)
				if (response.data.success) {
					let searchTerm = "";
					response.data.response.forEach(val => searchTerm += `${val.value}\n`);

					setIsFocused(true)
					setGuestiiSearchTerm(searchTerm)
					handleGuestiiSearch(searchTerm, response.data.response)
				} else {
					setValidationError(response.data.message)
				}
			} catch (error) {
				const eMessage = error.response.data.error || error.response.data.message
				setValidationError(eMessage)
			}

			setFileUploading(false)
		}
	};

	const cancelEvent = async (event) => {
		const confirmCancellation = await window.confirm("Are you sure you want to cancel this event? This action can not be undone.")

		if (confirmCancellation) {
			const userId = localStorage.getItem("_id")
			const expiry = localStorage.getItem("expiry")
			if (!userId || !expiry) {
				locationStorage.removeItem("_id")
				locationStorage.removeItem("expiry")
				window.location = "/connect"
			}

			try {
				const cancellation = await axios.post(`/api/hub/cancel-event/${userId}/${expiry}`, event);
				window.location.reload()
			} catch (e) {
				localStorage.removeItem("_id")
				localStorage.removeItem("expiry")
				window.location = "/connect"
			}
		}
	}

	const deleteEvent = async (event) => {
		const confirmDelete = await window.confirm("Are you sure you want to cancel this event? This action can not be undone.")

		if (confirmDelete) {
			const userId = localStorage.getItem("_id")
			const expiry = localStorage.getItem("expiry")
			if (!userId || !expiry) {
				locationStorage.removeItem("_id")
				locationStorage.removeItem("expiry")
				window.location = "/connect"
			}

			try {
				const cancellation = await axios.post(`/api/hub/delete-event/${userId}/${expiry}`, event);
				window.location.reload()
			} catch (e) {
				localStorage.removeItem("_id")
				localStorage.removeItem("expiry")
				window.location = "/connect"
			}
		}
	}

	const removeLockoutTime = async () => {
		const confirmRemove = await window.confirm("Are you sure you want to remove the set lockout time?")

		if (confirmRemove) {
			const userId = localStorage.getItem("_id")

			if (!userId) {
				window.location = "/connect"
			}

			let response;
			try {
				response = await axios.post(`/api/hub/remove-event-lockout/${userId}`, {
					eventId: indEvent._id
				});

			} catch (e) {
				console.log(e)
				localStorage.removeItem("_id")
				window.location = "/connect"
			}


			const state = { from: response.data.newEvent };
			sessionStorage.setItem('navigationState', JSON.stringify(state));
			window.location.reload()
		}
	}

	const toggleActiveTeamNav = (nav) => {
		if (activeTeamNav.includes(nav)) {
			setActiveTeamNav((prev) => [...prev].filter(n => n !== nav))
		} else {
			setActiveTeamNav((prev) => [...prev, nav])
		}
	} 

	return (
		<div className={`${styles.ind_container} ${indEventNav === "Guestiis" && styles.extended_width} ${isFocused && styles.customFocused} ${styles.fadeContainer}`}>
			{isFocused
				? <button className={styles.ind_close} onClick={() => setIsFocused(false)}><i className={`fa-solid fa-chevron-left ${styles.s1}`}></i></button>
				: <button className={styles.ind_close} onClick={() => handleOpen('close')}><i className={`fa-solid fa-xmark ${styles.s1}`}></i></button>
			}

		    {(validationError && validationError.length > 0) &&
		        <div className={styles.error_banner}>
		          	<p className={styles.error_text}>{validationError}</p>
		        </div>
		    }

			<div className={`${(indEventNav === "Guestiis" || indEventNav === "Team" || indEventNav === "Announcements") ? styles.ind_wrapper : styles.ind_wrapper_main} ${(showRatings || showTags || promotersPopup) && styles.toggled_hidden_container} ${styles.fadeLaterContainer}`}>
				<div className={(indEventNav === "Guestiis" || indEventNav === "Team" || indEventNav === "Announcements") ? styles.event_layout : styles.event_layout_main}>

					{!isFocused && indEvent.status === "Cancelled" &&
						<div className={styles.notify_cancelled}>
							<p className={styles.bold}>This event has been cancelled.</p>
						</div>
					}

					{indEvent.lockout_time &&
						<button className={styles.lockout_banner} onClick={() => removeLockoutTime()}>
							<p className={styles.s1}>An event lockout time is set to {formatTime(indEvent.lockout_time)}. Click here to remove.</p>
						</button>
					}

					<div className={styles.event_info}>
						<div className={styles.indevent_banner}>
							<div className={styles.event_banner}>
								{(indEvent.banner_img_url && indEvent.banner_img_url !== "")
									? <img src={indEvent.banner_img_url}/>
									: <img src={guestii_gif} className={styles.lessWidth}/>
								}
							</div>

							<p className={styles.bold}>{indEvent.name}</p>
						</div>

						<div>
							<div className={styles.ind_flex_edit_row}>
								<p className={styles.bold}>{indEvent.name}</p>

								<button onClick={() => setShowMenu(!showMenu)}>
									<i className={`fa-solid fa-ellipsis-vertical ${styles.m1}`}></i>
								</button>

								{showMenu &&
									<div className={styles.ind_event_menu}>
										<button onClick={() => handleOpen('edit', indEvent)}>
											<i className={`fa-solid fa-pencil ${styles.s3}`}></i>
											<p className={styles.m1}>Edit</p>
										</button>

										<button onClick={() => handleOpen('lockout', indEvent)}>
											<i className={`fa-solid fa-clock ${styles.s3}`}></i>
											<p className={styles.m1}>Lockout</p>
										</button>

										{(indEvent.guestiis.length > 0 && indEvent.status !== "Cancelled") &&
											<button onClick={() => cancelEvent(indEvent)}>
												<i className={`fa-solid fa-ban ${styles.s3}`}></i>
												<p className={styles.m1}>Cancel</p>
											</button>
										}

										{(indEvent.guestiis.length === 0 || indEvent.status === "Cancelled") &&
											<button onClick={() => deleteEvent(indEvent)}>
												<i className={`fa-solid fa-trash-can ${styles.s3}`}></i>
												<p className={styles.m1}>Delete</p>
											</button>
										}
									</div>
								}
							</div>

							<div className={styles.event_info_grid}>
								<div className={styles.event_info_item}>
									<i className={`fa-solid fa-location-dot ${styles.s1}`}></i>
									<a className={styles.clickable_nav} href={`http://maps.google.com/?q=${indEvent.location.formatted_address}`} target="_blank"><p className={styles.s1}>{indEvent.location.formatted_address}</p></a>
								</div>

								<div className={styles.event_info_item}>
									<i className={`fa-solid fa-calendar-days ${styles.s1}`}></i>
									<p className={styles.s1}>{formatDate(indEvent.start_date)}</p>
								</div>

								<div className={styles.event_info_item}>
									<i className={`fa-solid fa-clock ${styles.s1}`}></i>
									<p className={styles.s1}>{convertTo24HourTime(indEvent.start_date)} - {convertTo24HourTime(indEvent.end_date)}</p>
								</div>

								<div className={styles.event_info_item}>
									<i className={`fa-solid fa-users ${styles.s1}`}></i>
									<p className={styles.s1}>{indEvent.capacity}{(indEvent.capacityOG && indEvent.capacityOG !== false) ? `/${indEvent.capacityOG} capacity` : ' invited'}</p>
								</div>
							</div>
						</div>
					</div>

					{indEvent.status !== "Cancelled" &&
						<div className={indEventNav === "Dashboard" ? styles.dashboard_outer : styles.event_custom_widget_main}>
							<div className={styles.event_manage_invites}>
								<button
									className={`${styles.event_manage_btn} ${indEventNav === "Dashboard" && styles.event_manage_btn_active}`}
									onClick={() => handleIndEventNav('Dashboard')}
								>
									<p className={styles.s1}>Dashboard</p>
								</button>
								<button
									className={`${styles.event_manage_btn} ${indEventNav === "Guestiis" && styles.event_manage_btn_active}`}
									onClick={() => handleIndEventNav('Guestiis')}
								>
									<p className={styles.s1}>Guestiis</p>
								</button>
								<button
									className={`${styles.event_manage_btn} ${indEventNav === "Team" && styles.event_manage_btn_active}`}
									onClick={() => handleIndEventNav('Team')}
								>
									<p className={styles.s1}>Team</p>
								</button>
								<button
									className={`${styles.event_manage_btn} ${indEventNav === "Announcements" && styles.event_manage_btn_active}`}
									onClick={() => handleIndEventNav('Announcements')}
								>
									<p className={styles.s1}>Announcements</p>
								</button>
							</div>

					        {indEventNav === "Dashboard" &&
								<DashboardModule
									indEvent={indEvent}
								/>
							}
						</div>
					}
				</div>

				{(indEventNav === "Team" && indEvent.status !== "Cancelled") &&
					<div className={styles.textAreaOutest}>
						<div className={`${styles.textAreaWrapper} ${mainGuestii && styles.textAreaWrapperExt}`}>
							<div className={styles.textAreaHeaderContainer}>
								{!mainLoading
									?
										<Select
											isMulti={true}
											options={searchableTeamMembers.map(item => { return {
											    value: item._id.toString(),
											    first_name: item.first_name,
											    last_name: item.last_name,
											    email: item.email,
											    role: item.role.name
											} })}
											closeMenuOnSelect={true}
											isDisabled={validationError}
											onFocus={() => setTeamFocused(true)}
										    formatOptionLabel={(option, { context }) => {
										        if (context === 'menu') {
										          	return (
										            	<div>
										            		<div style={{ display: 'flex', alignItems: 'center', columnGap: '.75rem' }}>
										            			<div className={styles.guestii_profile_rounded}><i className={`fa-solid fa-user ${styles.s1}`}></i></div>
										            			<div>
											              			<p className={styles.s1}>{option.first_name} {option.last_name}</p>
											              			<p className={styles.xs3}>{option.email}</p>
											              		</div>
										              		</div>

										              		<p className={styles.s1} style={{ marginTop: 10 }}>{option.role}</p>
										            </div>
										          )
										        }

										        return <div>{option.first_name} {option.last_name}</div>
										    }}
											styles={{
												control: (base, { isFocused }) => ({
													...base,
													height: 50,
													backgroundColor: '#01000D',
													borderRadius: 10,
													borderWidth: 3,
													borderStyle: 'solid',
													borderColor: validationError
														? 'red'
														: isFocused
														? 'rgba(68,157,209,1)'
														: 'rgba(68,157,209,0.3)',
													'&:hover': isFocused
														? { borderColor: 'rgba(68,157,209,1)' }
														: { borderColor: 'rgba(68,157,209,0.3)' }
												}),
												input: (base) => ({ ...base, color: '#fff' }),
												placeholder: (base) => ({ ...base, color: '#aaa' }),
											    multiValue: (base) => ({
											      	...base,
											      	backgroundColor: 'rgba(68,157,209,1)'
											    }),
											    multiValueRemove: (base) => ({
											      	...base,
											      	cursor: 'pointer',
											    }),
												multiValueLabel: (base) => ({ 
													...base,
													backgroundColor: "rgba(68,157,209,1)",
													color: '#fff'
												}),
												menu: (base) => ({
													...base,
													backgroundColor: '#161824',
													color: '#fff',
												}),
												menuList: (base) => ({
													...base,
													padding: "10px 0",
													height: 300,
												}),
											    option: (base, { isFocused }) => ({
											      	...base,
											      	backgroundColor: isFocused
											        	? 'rgba(68,157,209,1)'
											        	: 'transparent',
											      	color: '#fff',
											      	cursor: 'pointer',
											      	borderRadius: 7.5,
											      	'&:active': {
											        	backgroundColor: 'rgba(68,157,209,0.8)',
											      	},
											    }),
											}}
											onChange={(selected) => handleTeamSearch(selected)}
											value={teamSearchTerm && teamSearchTerm}
										/>
							        :
								        <div
							                className={`${styles.s1} ${styles.textareaContainerSelect} ${styles.textareaContainerFocused} ${styles.trueMaxWidth}`}
											disabled={true}
							            >
							            	<img src={guestii_gif} className={styles.logo_gif_loading}/>
							            </div>
								}

								{(!mainLoading && teamFocused) &&
									<button disabled={validationError} className={`${styles.check_team_btn} ${validationError && styles.errorBtn}`} onClick={() => handleTeamList()}>
										<p className={styles.xs3}>Invite!</p>
									</button>
								}

								{!teamFocused &&
									<div className={styles.team_nav_btns}>
										<button className={`${styles.team_nav_btn} ${activeTeamNav.includes("SuperAdmin") && styles.team_nav_btn_active}`} onClick={() => toggleActiveTeamNav("SuperAdmin")}>
											<div className={styles.team_nav_btn_icon}>
												<i className={`fa-solid fa-user ${styles.s1}`}></i>
											</div>
											<p className={styles.xs3}>Account Owners</p>
										</button>

										<button className={`${styles.team_nav_btn} ${activeTeamNav.includes("Event Manager") && styles.team_nav_btn_active}`} onClick={() => toggleActiveTeamNav("Event Manager")}>
											<div className={styles.team_nav_btn_icon}>
												<i className={`fa-solid fa-calendar-days ${styles.s1}`}></i>
											</div>
											<p className={styles.xs3}>Event Managers</p>
										</button>

										<button className={`${styles.team_nav_btn} ${activeTeamNav.includes("Promoter") && styles.team_nav_btn_active}`} onClick={() => toggleActiveTeamNav("Promoter")}>
											<div className={styles.team_nav_btn_icon}>
												<i className={`fa-solid fa-square-envelope ${styles.s1}`}></i>
											</div>
											<p className={styles.xs3}>Promoters</p>
										</button>

										<button className={`${styles.team_nav_btn} ${activeTeamNav.includes("Scanner") && styles.team_nav_btn_active}`} onClick={() => toggleActiveTeamNav("Scanner")}>
											<div className={styles.team_nav_btn_icon}>
												<i className={`fa-solid fa-qrcode ${styles.s1}`}></i>
											</div>
											<p className={styles.xs3}>Scanners</p>
										</button>
									</div>
								}
				            </div>

							{!teamFocused &&
		                		<TeamTableDisplay
		                			indEvent={indEvent}
		                			mainLoading={mainLoading}
		                			handleDelete={handleDeleteTeam}
		                			toggledMenu={toggledMenu}
		                			setToggledMenu={setToggledMenu}
		                			activeTeamNav={activeTeamNav}
		                			promotersPopup={promotersPopup}
		                			setPromotersPopup={setPromotersPopup}
		                			setMainGuestii={setMainGuestii}
		                			mainGuestii={mainGuestii}
		                			setTeamFocused={setTeamFocused}
		                		/>
	                		}

	                		{teamFocused &&
	                			<div className={styles.untouch_module} onClick={() => setTeamFocused(false)}>
	                				<p className={styles.m1}>Touch anywhere here to exit invite module</p>
	                			</div>
	                		}       
				        </div>
			        </div>
			    }

				{(indEventNav === "Guestiis" && indEvent.status !== "Cancelled") &&
					<div className={styles.textAreaOutest}>
						<div className={`${styles.textAreaWrapper} ${indEventNav === "Guestiis" && styles.textAreaWrapperGuestii}`}>
							{isFocused &&
								<>
									<div className={styles.textAreaHeaderContainer}>
										{!mainLoading
											?
										        <textarea
									                className={`${styles.s1} ${styles.textareaContainer} ${styles.trueMaxWidth} ${validationError && styles.textareaContainerRed}`}
									                placeholder={`Invite a guestii by full name or phone number, with tags\n\nBruce Lee (VIP, CREW)\n0412 345 678 (GA)\n0498 765 432`}
									                onChange={(e) => setGuestiiSearchTerm(e.target.value)}
									                value={guestiiSearchTerm}
													onFocus={() => setIsFocused(true)}
													disabled={mainLoading || validationError}
									            ></textarea>
									        :
										        <div
									                className={`${styles.s1} ${styles.textareaContainer} ${styles.textareaContainerFocused} ${styles.trueMaxWidth}`}
													disabled={true}
									            >
									            	<img src={guestii_gif} className={styles.logo_gif_loading}/>
									            </div>
										}

										{(isFocused && !mainLoading) &&
											<button disabled={validationError} className={`${styles.check_guestiis_btn} ${validationError && styles.errorBtn}`} onClick={() => handleGuestiiSearch()}>
												<p className={styles.xs3}>Check!</p>
											</button>
										}

							            <div className={styles.bulkUploadContainer}>
								            <button className={styles.bulkUpload} onClick={() => setShowTemplates(!showTemplates)} disabled={mainLoading}>
								            	<i className={`fa-solid fa-download ${styles.s1}`}></i>
								            	<p className={styles.s1}>Templates</p>
								            </button>

								            {showTemplates &&
								            	<div className={styles.templatesContainer}>
								            		<button onClick={() => handleDownloadTemplate('xlsx')}><p className={styles.s1}>Excel template</p></button>
								            		<button onClick={() => handleDownloadTemplate('csv')}><p className={styles.s1}>CSV template</p></button>
								            	</div>
								        	}

								            <button className={styles.bulkUpload} disabled={fileUploading || mainLoading} onClick={() => fileInputRef.current.click()}>
								            	{fileUploading
								            		? <img src={guestii_gif} className={styles.logo_gif}/>
								            		:
								            			<>
															<i className={`fa-solid fa-upload ${styles.s1}`}></i>					            
											            	<p className={styles.s1}>Bulk Upload</p>
								            			</>
								            	}
								            </button>

											<input
												type="file"
												ref={fileInputRef}
												style={{ display: 'none' }}
												onChange={handleFileChange}
												accept=".csv, .xlsx"
											/>
							            </div>
						            </div>

									{(!mainLoading && isFocused) &&
					                	<div className={styles.table_container_indguestii_indevent}>
					                  		{filteredUsers && filteredUsers.length > 0
					                    		?
					                      			<>
					                        			{filteredUsers.map((user, idx) => {
					                        				return (
																<div className={`${styles.guestii_invited_ind_indteam} ${(user.exists || user.exists_externally) && styles.invalid_search} ${(!user.valid && !user.exists && !user.exists_externally) && styles.no_ticket_search}`}>
																	<div className={styles.guestii_inner_split}>
																		<div className={styles.guestii_profile_rounded}><i className={`fa-solid fa-user ${styles.s1}`}></i></div>

																		<div className={styles.guestii_profile_info}>
																			<p className={styles.s1}>{user.value}</p>
																			<p className={styles.xs2}>{user.exists ? "Already invited!" : user.valid ? "Invite to Guestii!" : user.exists_externally ? "User already exists" : "Static Guestii (no ticket)"}</p>
																		</div>

																		{(!user.exists && !user.exists_externally) &&
													                      	<button className={`${styles.medal_container}`} onClick={() => handleGuestiiInviteList(user)}>
													                        	<i className={`fa-solid fa-plus`}></i>
													                      	</button>
												                      	}
												                    </div>

												                    {(!user.exists && !user.exists_externally) &&
											                    		<div className={styles.inner_invite_content}>
																            <div className={`${styles.widget_action_container_in} ${styles.numberInput}`}>
																                <label className={styles.xs3}>
																                  	Plus-Ones:
																                </label>

																                <div className={styles.customNumberInput}>
																                	<button
																                		className={`${styles.numberControl}`}
																                		onClick={() => handleFilteredUsersPlusOnes(user, '-')}
																                	>
																                		<i className={`fa-solid fa-minus ${styles.xs2}`}></i>
																                	</button>

																                	<input type="number" value={user.plusOnes} className={styles.xs3}/>

																                	<button
																                		className={`${styles.numberControl}`}
																                		onClick={() => handleFilteredUsersPlusOnes(user, '+')}
																                	>
																                		<i className={`fa-solid fa-plus ${styles.xs2}`}></i>
																                	</button>
																                </div>
																            </div>

															            	<p className={styles.xs3}>{(user.tags && user.tags.length > 0) ? `Tags: ${user.tags.join(", ")}` : "-"}</p>
															            </div>
														            }
																</div>
						                        			)
					                        			})}
					                      			</>
					                    		: <p className={`${styles.m1} ${styles.noResultsMain}`}>Use the search bar above to invite your first Guestii!</p>
					                  		}
					                	</div>
				                	}

						            {(isFocused && filteredUsers.length > 0) &&
										<button className={`${styles.prev_control_btn_absolute} ${styles.next_btn}`} onClick={() => handleGuestiiInviteListBulk()}>
											<p className={styles.s1}>Invite All Guestii's!</p>
										</button>
									}
								</>
							}


		                	{!isFocused &&
		                		<div className={styles.guestii_queue_container}>
		                			<GuestiiTopbar
		                				indEvent={indEvent}
										setNodes={setNodes}
										setNodesOG={setNodesOG}
										setNodesFull={setNodesFull}
										nodes={nodes}
										nodesOG={nodesOG}
										nodesFull={nodesFull}
										setIsFocused={setIsFocused}
		                			/>

		                			<GuestiiSidebar
		                				indEvent={indEvent}
										setNodes={setNodes}
										setNodesOG={setNodesOG}
										setNodesFull={setNodesFull}
										nodes={nodes}
										nodesOG={nodesOG}
										nodesFull={nodesFull}
		                			/>

			                		<GuestiiTableDisplay
			                			indEvent={indEvent}
			                			mainLoading={mainLoading}
			                			mainGuestii={mainGuestii}
			                			setMainGuestii={setMainGuestii}
			                			handleDelete={handleDeleteGuestii}
			                			setIndEvent={setIndEvent}
			                			showRatings={showRatings}
			                			setShowRatings={setShowRatings}
			                			toggledMenu={toggledMenu}
			                			setToggledMenu={setToggledMenu}
			                			showTags={showTags}
			                			setShowTags={setShowTags}
										setNodes={setNodes}
										setNodesOG={setNodesOG}
										setNodesFull={setNodesFull}
										nodes={nodes}
										nodesOG={nodesOG}
										nodesFull={nodesFull}
			                		/>
		                		</div>
				        	}				        
				        </div>
			        </div>
			    }

		        {(indEventNav === "Announcements" && indEvent.status !== "Cancelled") &&
		        	<div className={styles.textAreaOutestTeam}>
						<div className={styles.annoucements_container}>
			              	<textarea
				                className={`${styles.s1} ${styles.textareaContainerBigger}`}
				                placeholder="Create a new event announcement for your guestii's..."
				                onChange={(e) => handleAnnouncementMsg(e.target.value)}
				                value={announcementMsg}
				            ></textarea>

				            <button className={styles.submit_announcement} onClick={() => sendAnnouncement()}><p className={styles.s1}>></p></button>
				            

				            <div className={styles.channels_container}>
				            	<button className={activeChannel === "Guestiis" && styles.channels_container_active} onClick={() => setActiveChannel("Guestiis")}><p>Guestiis</p></button>
				            	<button className={activeChannel === "Team" && styles.channels_container_active} onClick={() => setActiveChannel("Team")}><p>Team</p></button>
				            </div>

			              	{(indEvent['announcements'] && indEvent['announcements'][activeChannel.toLowerCase()] && indEvent['announcements'][activeChannel.toLowerCase()].length > 0)
			              		?
				                	<div className={styles.outer_announcements}>
	                        			{sortByDateTime(indEvent['announcements'][activeChannel.toLowerCase()]).map((msg, idx) => (
	                          				<div key={idx} className={styles.annoucement_msg_container}>
												<div className={styles.event_line}>
													<div className={styles.line_circle}/>
													{(idx !== indEvent['announcements'][activeChannel.toLowerCase()].length - 1) && <div className={styles.line}/>}
												</div>
						
												<div>
													<p className={styles.s1}>{formatDate(msg.date)}</p>
													<p className={styles.xs3}>{convertTo24HourTime(msg.date)}</p>
												</div>

												<div className={styles.annoucement_msg}>
	                            					<p className={styles.s1}>{msg.msg}</p>

	                            					<button className={styles.annoucement_delete} onClick={() => deleteAnnouncement(msg.id)}>
	                            						<i className={`fa-solid fa-trash-can ${styles.s1}`}></i>
	                            					</button>
	                            				</div>
	                          				</div>
	                        			))}
				                	</div>
				                : <div className={styles.outer_announcements_none}><p>Send your first annoucement to the event {activeChannel.toLowerCase()}</p></div>
			              	}

			            </div>
		            </div>
				}
	        </div>
		</div>
	)
}

const IndEvent = ({ indEvent, setIndEvent, handleOpen }) => {
	const [isLoading, setIsLoading] = useState(false);
	const [teamMembers, setTeamMembers] = useState([])
	const [teamMembersOG, setTeamMembersOG] = useState([])
	const [isAuthenticated, setIsAuthenticated] = useState(true);
	const [showRatings, setShowRatings] = useState(false)
	const [showTags, setShowTags] = useState(false)
	const [toggledMenu, setToggledMenu] = useState(null)
	const [promotersPopup, setPromotersPopup] = useState(false)
	const [promoterLimits, setPromoterLimits] = useState({})
	const [teamSearchTerm, setTeamSearchTerm] = useState([])
	const [teamFocused, setTeamFocused] = useState(false)


	useEffect(() => {
		const handleTeamMembers = async () => {
			setIsLoading(true)

			const userId = localStorage.getItem("_id")
			const expiry = localStorage.getItem("expiry")
			if (!userId || !expiry) {
				locationStorage.removeItem("_id")
				locationStorage.removeItem("expiry")
				window.location = "/connect"
			}

			try {
				const retrieve = await axios.get(`/api/team/get-team-members/${userId}/${expiry}/${true}`);
				setTeamMembers(retrieve.data.teamMembers)
				setTeamMembersOG(retrieve.data.teamMembers)
			} catch (e) {
				localStorage.removeItem("_id")
				localStorage.removeItem("expiry")
				window.location = "/connect"
			}

			setIsLoading(false)
		}

		handleTeamMembers()
	}, []);

	return (
		<>			
			{!isLoading &&
				<>
					{isAuthenticated
						?
							<>
								<IndEventPage { ... { indEvent, setIndEvent, handleOpen, teamMembers, setTeamMembers, teamMembersOG, showRatings, setShowRatings, toggledMenu, setToggledMenu, showTags, setShowTags, setPromotersPopup, promotersPopup, teamSearchTerm, setTeamSearchTerm, teamFocused, setTeamFocused } }/>
								{showRatings && <Ratings { ... { indEvent, setShowRatings, toggledMenu } }/>}
								{showTags && <Tags { ... { indEvent, setShowTags, toggledMenu, setIndEvent } }/>}
								{promotersPopup && <Promoters { ... { promotersPopup, setPromotersPopup, indEvent, setIndEvent, promoterLimits, setPromoterLimits, teamSearchTerm, setTeamSearchTerm, setTeamFocused } }/>}
							</>
						: <Forbidden />
					}
				</>
			}
		</>
	);
};

export default IndEvent;